export default async function iziCanBeBound(productId) {
  if (!productId) {
    console.warn('[InPostPay] iziCanBeBound called without productId');
    return false;
  }

  const inpostPayWidget = document.querySelector(`.izi-widget-product[data-product-id="${productId}"]`);
  const formContainingWidget = inpostPayWidget ? inpostPayWidget.closest('form') : null;

  const fpfProductInput = window.document.querySelector(`input[name="_fpf_product_id"][value="${productId}"]`);
  const fpfFormId = fpfProductInput ? fpfProductInput.getAttribute('form') : null;
  const fpfForm = fpfFormId ? window.document.getElementById(fpfFormId) : null;

  const formProductId =
    formContainingWidget ||
    window.document.querySelector(`form[data-product_id="${productId}"]`) ||
    fpfForm;

  if (!formProductId) return true;

  const addToCartButton = formProductId.querySelector(".single_add_to_cart_button");
  const addToCartButtonDisabledClass = formProductId.querySelector(".single_add_to_cart_button.disabled");
  const buttonProductId = formProductId.querySelector(`a.add_to_cart_button[data-product_id="${productId}"]`);
  const productListingItem = formProductId.querySelector(`.post-${productId}`);
  const pewcItems = formProductId.querySelectorAll(`form.cart .pewc-item`);
  const wapfRequiredInputs = formProductId.querySelectorAll(`.wapf input[required]`);
  const fpfRequiredFields = formProductId.querySelectorAll(`.fpf-required`);

  if (!buttonProductId && !formProductId && !productListingItem) return true;

  if ((addToCartButton && addToCartButton.disabled) || addToCartButtonDisabledClass) return false;

  if (wapfRequiredInputs.length > 0) {
    const isWapfRequiredInputFilled = Array.from(wapfRequiredInputs).every(input => input.value);
    if (!isWapfRequiredInputFilled) return false;
  }

  if (fpfRequiredFields.length > 0) {
    const isVisible = (element) => {
      if (!element) {
        return false;
      }

      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    };

    const isFpfFieldValid = (field, index) => {
      const fieldWrapper = field.closest('.fpf-field') || field;

      if (!isVisible(fieldWrapper)) {
        return true;
      }

      const radioInputs = field.querySelectorAll(`input[type="radio"]`);

      if (radioInputs.length > 0) {
        const radioStates = Array.from(radioInputs).map((input) => ({
          name: input.name,
          id: input.id,
          value: input.value,
          checked: input.checked,
          visible: isVisible(input),
        }));

        return Array.from(radioInputs).some(input => input.checked);
      }

      const inputs = field.querySelectorAll(`input, textarea, select`);

      const everyResult = Array.from(inputs).every((input, inputIndex) => {
        const inputVisible = isVisible(input);
        const inputData = {
          index: inputIndex,
          tagName: input.tagName,
          type: input.type,
          name: input.name,
          id: input.id,
          value: input.value,
          trimmedValue: String(input.value || '').trim(),
          visible: inputVisible,
          disabled: input.disabled,
        };

        if (!inputVisible) {
          return true;
        }

        if (input.type === 'hidden' || input.type === 'radio' || input.type === 'checkbox') {
          return true;
        }

        return !!String(input.value || '').trim();
      });

      return everyResult;
    };

    const isFpfRequiredFieldFilled = Array.from(fpfRequiredFields).every((field, index) => isFpfFieldValid(field, index));

    if (!isFpfRequiredFieldFilled) {
      return false;
    }
  }

  if (pewcItems.length > 0) {
    const pewcFormFieldsInputs = formProductId.querySelectorAll(`.pewc-item.required-field input[type="text"]`);
    const pewcFormFieldsSelects = formProductId.querySelectorAll(`.pewc-item select`);
    const pewcFormFieldsUploads = formProductId.querySelectorAll(`.pewc-item.required-field input.pewc_file_data`);

    if (pewcFormFieldsInputs.length > 0) {
      const isVariationSelected = Array.from(pewcFormFieldsInputs).every(field => field.value);
      if (!isVariationSelected) return false;
    }

    if (pewcFormFieldsSelects.length > 0) {
      const isVariationSelected = Array.from(pewcFormFieldsSelects).every(field => field.value);
      if (!isVariationSelected) return false;
    }

    if (pewcFormFieldsUploads.length > 0) {
      const isFileUploaded = Array.from(pewcFormFieldsUploads).every(field => field.value);
      if (!isFileUploaded) return false;
    }
  }

  if (formProductId) {
    const submitButton = getSingleProductAddToCartButton(formProductId);

    if (!submitButton) {
      return true;
    }

    const isNotDisabled = isAddToCartButtonEnabled(submitButton);

    if (!isNotDisabled) {
      submitButton.click();
    }

    return isNotDisabled;
  }

  if (buttonProductId) {
    const isSimple = !buttonProductId.classList.contains("product_type_variable");
    if (!isSimple) buttonProductId.click();
    return isSimple;
  }

  if (productListingItem) {
    const isInStock = !productListingItem.classList.contains("outofstock");
    if (!isInStock) formProductId.querySelector(`a[data-product_id="${productId}"]`).click();
    return isInStock;
  }
}

function getSingleProductAddToCartButton(form) {
  return (
    form.querySelector(`button[type="submit"]`) ||
    form.querySelector(`.single_add_to_cart_button`)
  );
}

function isAddToCartButtonEnabled(button) {
  return (
    !button.disabled &&
    !button.classList.contains("disabled") &&
    !button.classList.contains("wc-variation-selection-needed")
  );
}
